export default {
  bind: function (el, binding) {
    if (el.childElementCount == binding.arg) {
      el.style.display = 'none'
    }
  }
}
